import { FormControl, FormGroup } from '@angular/forms';

import { FormType } from './types';

export const createForm = () => {
  return new FormGroup<FormType>({
    uuid: new FormControl({ value: '', disabled: true }, { nonNullable: true }),
    filename: new FormControl({ value: null, disabled: true }),
    name: new FormControl(null),
    description: new FormControl(null),
  });
};
